import type { BranchDto } from 'korint-sdk';

// Partial: a STOP branch has no funnel to reopen, so it offers no edit link.
const branchTypeFunnelPrefix: Partial<Record<NonNullable<BranchDto['branchType']>, string>> = {
  NEW_BUSINESS: '/discovery',
  MTA: '/mta',
  RENEWAL: '/renewal',
  REPRICING: '/repricing',
};

export const branchFunnelPath = ({
  branchType,
  productCustomPath,
  customerId,
  policyId,
  branchId,
}: {
  branchType: BranchDto['branchType'];
  productCustomPath: string;
  customerId: string;
  policyId: string;
  branchId: string;
}): string | undefined => {
  const prefix = branchType && branchTypeFunnelPrefix[branchType];
  return prefix && `${prefix}${productCustomPath}/${customerId}/${policyId}/${branchId}`;
};
